export { default as CompanyViewHeadUser } from './CompanyViewHeadUser';
